import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlurOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blur_on"}/>
}
